import CanvasManager from "slotworks/graphics/canvas/canvas-manager";
import Contract from "slotworks/utils/contracts/contract";
class GPUUploader {

    private queue: Upload[] = [];

    public upload(texture: PIXI.Texture) {
        const uploadContract = new Contract<void>((resolve) => {
            this.queue.push({ texture, resolve } as Upload);

            if (this.queue.length === 1) {
                this.uploadNext();
            }
        });

        return uploadContract;
    }

    private uploadNext() {
        if (this.queue.length) {

            const upload = this.queue.pop();
            const sprite = new PIXI.Sprite(upload.texture);

            CanvasManager.renderer.plugins.prepare.upload(sprite, () => {
                upload.resolve();
                this.uploadNext();
            });
        }
    }

}

interface Upload {
    texture: PIXI.Texture;
    resolve: () => void;
}

export default new GPUUploader();
